var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "#323232",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68567 9.68567l-5.26376e-08 2.26865e-07c.236925-1.02113 1.16697-1.72914 2.21433-1.68567l-1.23132e-07 6.82006e-09c1.17217-.0649246 2.17705.828297 2.25 2 0 1.50391-2.15 2-2.15 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 15.75v0c0 .0690356-.0559644.125-.125.125 -.0690356 0-.125-.0559644-.125-.125 0-.0690356.0559644-.125.125-.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.625h-5.46392e-09c.0690356-3.01764e-09.125.0559644.125.125"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24h-24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.76267dbb6a4c9b0d258b5e439de1f86e.svg";
export { ForwardRef as ReactComponent };